import cn from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import PostingsApi from '../../../../../API/shipment/postings-api';
import Stocks1cApi from '../../../../../API/shipment/stocks1c-api';
import { changeShipmentPosting } from '../../../../../actions/postings';
import default_image from '../../../../../assets/media/icons/products.png';
import { Column, Row, WhiteBlock } from '../../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../../components/Basic/Buttons';
import { DropDown, LinkBlue, NavLink } from '../../../../../components/Basic/Elements';
import { Input, Select } from '../../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../../components/Basic/Table';
import { Text, TextGrey, Tooltip } from '../../../../../components/Basic/WrapsStyle';
import BarcodesBlock from '../../../../../components/Common/Input/Barcodes';
import ProviderList from '../../../../../components/Common/Input/ProviderList';
import {
  IP_LIST_NUMBER,
  IP_MAP,
  IP_NUMBER_MAP,
  MARKET_IP,
  TO_REPORT,
  TO_SHIPMENT,
  TYPE_BUTTONS
} from '../../../../../constans';
import { formFullDate, formFullDateWithSeconds, getDateMonth } from '../../../../../utils';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';

let OPERATION_MAP = {
  op0: 'ОП_0',
  op1: 'ОП_1',
  op2: 'ОП_2',
  op3: 'ОП_3',
};
const PostingLine = ({
  MODES,
  FILTER,
  tab,
  shipmentMode = true,
  packagingMode = false,
  order = {},
  shipment = {},
  map = {},
  postingsSelect = {},
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  setOpenChzn = () => { },
  changePostingSelect = () => { },
  isMany = false,
  isDisabledPrint = () => { },
  stocks1cArray = [],
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);
  const [openSklad, setOpenSklad] = useState({ state: false, product: {}, productProvider: {} });

  const [info, setInfo] = useState(false);
  const dispatch = useDispatch();

  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: id, productId, field, value, action } }).then((r) => {
      dispatch(changeShipmentPosting(r.posting));
    });
  };

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const scan_time_order = order.scan_time.pick ? formFullDateWithSeconds(order.scan_time.pick) : null;
  const second_scan_time_order = order.scan_time.packager ? formFullDateWithSeconds(order.scan_time.packager) : null;
  const sort_scan_time_order = order.scan_time.sort ? formFullDateWithSeconds(order.scan_time.sort) : null;

  return (
    <>
      <TableLine>
        <TableCell width={WIDTH_POSTING[15]}>
          <CheckButton
            checked={postingsSelect[order.posting_number]}
            onSelect={() => changePostingSelect(order.posting_number)}
          />
        </TableCell>
        <TableCell width={WIDTH_POSTING[0]} minWidth={WIDTH_POSTING[0]}>
          {order.posting_number}
          {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
          <Row style={{ width: '100%' }}>
            {isMany && (
              <NavLink
                to={TO_SHIPMENT(order.shipmentId)}
                target={'_blank'}
                className={styles.scan_time}
                style={{ fontSize: '16px', width: 'auto', marginRight: '5px' }}
              >
                {getDateMonth(order.dates.shipment_date)}
              </NavLink>
            )}
            {order.market === 'wb' && (
              <TextGrey style={{ fontSize: '13px', color: '#6c11c9' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'yandex' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'ozon' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'megamarket' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
            )}
            {order.sale_schema === 'fbs' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{' fbs'}</TextGrey>
            )}
            {order.sale_schema === 'fbo' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{' fbo'}</TextGrey>
            )}
            {order.sale_schema === 'express' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{' express'}</TextGrey>
            )}
            {order.realization_id <= 365 && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{' 2024 год'}</TextGrey>
            )}

            {order.report_id && (
              <LinkBlue to={TO_REPORT(order.report_id)} target={'_blank'} style={{ fontSize: '14px' }}>
                {` -> ${order.report_id}`}
              </LinkBlue>
            )}
          </Row>
          <div className={styles.scan_time} onMouseOver={() => setInfo(true)} onMouseLeave={() => setInfo(false)}>
            {scan_time_order} <br />
            {info && (
              <DropDown styles={styles.all_info} close={() => setInfo(false)}>
                <WhiteBlock styles={styles.init}>
                  <TextGrey style={{ marginBottom: '4px' }}>Пропик:</TextGrey>
                  <Text fontSize={18} fontWeight={600}>{`${order.scan_user.pick}`}</Text>
                  <div className={styles.scan_time}>({scan_time_order})</div>

                  {second_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Упаковка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.packager}`}</Text>
                      <div className={styles.scan_time}>
                        ({second_scan_time_order}){' '}
                        {order.scan_id.packager && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.packager}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  {sort_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Сортировка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.sort}`}</Text>
                      <div className={styles.scan_time}>
                        ({sort_scan_time_order}){' '}
                        {order.scan_id.sort && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.sort}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </WhiteBlock>
              </DropDown>
            )}
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[14]} center>
          {order.dates.shipment_date && (
            <NavLink
              to={TO_SHIPMENT(order.shipment_id)}
              target={'_blank'}
              className={styles.scan_time}
              style={{ fontSize: '18px' }}
            >
              {getDateMonth(order.dates.shipment_date)}
            </NavLink>
          )}
        </TableCell>
        <TableCell width={WIDTH_POSTING[1]} minWidth={WIDTH_POSTING[1]}>
          <Column>
            {order.products.map((p, k) => {
              const data = map[p.offer_id] || {};
              const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
              const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
              return (
                <Column key={`${order.posting_number}-${p.offer_id}-1`}>
                  <div key={k} className={styles.div_line_images}>
                    <div className={styles.wrapper}>
                      <img
                        onClick={() => openImageViewer(img)}
                        className={styles.preview}
                        src={img.length > 0 ? img[0] : undefined}
                      />
                    </div>
                    <Column>
                      <div className={styles.name}>
                        {`${p.ordered_quantity} x ${p.name}  `}
                        <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                          {p.offer_id}
                        </div>
                      </div>
                      {scan_time && (
                        <div className={styles.scan_time}>
                          {scan_time} {p.scan_user && `(${p.scan_user})`}
                        </div>
                      )}
                    </Column>
                  </div>

                  {p.chzn.is_has && (
                    <Row style={{ marginBottom: '10px' }}>
                      <TextGrey>Маркировка: </TextGrey>
                      {p.chzn.value.length > 0 && !p.chzn.is_missing && (
                        <p className={styles.chzn_num}>{p.chzn.value}</p>
                      )}
                      {p.chzn.is_missing && <p className={styles.chzn_not}>НЕТ МАРКИРОВКИ</p>}
                      <Button
                        className={styles.color_blue}
                        onClick={() => setOpenChzn({ open: true, product: p, posting: order })}
                      >
                        {p.chzn.value.length ? 'редактировать' : 'ввести маркировку'}
                      </Button>
                      {/*
                      <Input value={p.number_chzn} onBlur={(v) => changeData(p._id, 'number_chzn', v)} />
*/}
                    </Row>
                  )}
                </Column>
              );
            })}
          </Column>
        </TableCell>
        {shipmentMode && (
          <TableCell width={WIDTH_POSTING[6]} minWidth={WIDTH_POSTING[6]} center={true}>
            <Column center={true}>
              {order.products.map((p, k) => (
                // eslint-disable-next-line react/no-array-index-key
                <Row key={`${order.posting_number}-${p.offer_id}-2`} className={styles.div_line}>
                  <div className={styles.num}>
                    {/*  {p.common_quantity || 0} */}
                    {p.real_quantity === p.common_quantity ? (
                      <>{p.common_quantity || 0}</>
                    ) : (
                      <>
                        {p.real_quantity || 0}{' '}
                        <span style={{ fontWeight: '400', fontSize: '20px', color: 'grey' }}>
                          / {p.common_quantity || 0}
                        </span>
                      </>
                    )}
                  </div>
                </Row>
              ))}
            </Column>
          </TableCell>
        )}
        {shipmentMode && (
          <TableCell width={WIDTH_POSTING[4]} minWidth={WIDTH_POSTING[4]} center={true}>
            <Column center={true}>
              {order.products.map((p, k) => (
                // eslint-disable-next-line react/no-array-index-key
                <Row key={`${order.posting_number}-${p.offer_id}-2`} className={styles.div_line}>
                  {p.history_1c?.map((item) => OPERATION_MAP[item.op_name])?.join(' -> ')}
                </Row>
              ))}
            </Column>
          </TableCell>
        )}

        {shipmentMode === MODES[0] && (
          <>
            <TableCell width={WIDTH_POSTING[6]} minWidth={WIDTH_POSTING[6]} center={true}>
              <Column center={true}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Row
                    key={`${order.posting_number}-${p.offer_id}-2`}
                    className={styles.div_line}
                    style={{ alignSelf: 'center' }}
                  >
                    {p.prices?.nds}
                  </Row>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[6]} minWidth={WIDTH_POSTING[6]} center={true}>
              <Column center={true}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Row
                    key={`${order.posting_number}-${p.offer_id}-2`}
                    className={styles.div_line}
                    style={{ alignSelf: 'center' }}
                  >
                    {p.prices?.purchase}
                  </Row>
                ))}
              </Column>
            </TableCell>
            {tab === 5 && (
              <TableCell width={WIDTH_POSTING[6]} minWidth={WIDTH_POSTING[6]} center={true}>
                <Column style={{ alignItems: 'center' }}>
                  {order.products.map((p, k) => {
                    let map_1c = stocks1cArray?.filter((item) => item.skus.includes(p.provider_sku))?.slice(0, 1)[0];
                    return (
                      <div key={`${order.posting_number}-${p.offer_id}-18`} className={styles.div_line}>
                        {/*  {map_1c?.price_nds_avg} */}

                        {p.stock_41?.reserved?.map((p) => p.purchase_1c_nds).join(' / ')}
                      </div>
                    );
                  })}
                </Column>
              </TableCell>
            )}
            {tab === 2 && (
              <TableCell width={WIDTH_POSTING[6]} minWidth={WIDTH_POSTING[6]} center={true}>
                <Column center={true}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={`${order.posting_number}-${p.offer_id}-2`}
                      className={styles.div_line}
                      style={{ alignSelf: 'center' }}
                    >
                      {p.price?.toFixed(2)}
                    </Row>
                  ))}
                </Column>
              </TableCell>
            )}
            {tab === 3 && (
              <TableCell width={WIDTH_POSTING[6]} minWidth={WIDTH_POSTING[6]} center={true}>
                <Column center={true}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={`${order.posting_number}-${p.offer_id}-2`}
                      className={styles.div_line}
                      style={{ alignSelf: 'center' }}
                    >
                      {p.prices?.op1?.toFixed(2)}
                    </Row>
                  ))}
                </Column>
              </TableCell>
            )}
            {tab === 4 && (
              <TableCell width={WIDTH_POSTING[6]} minWidth={WIDTH_POSTING[6]} center={true}>
                <Column center={true}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Row
                      key={`${order.posting_number}-${p.offer_id}-2`}
                      className={styles.div_line}
                      style={{ alignSelf: 'center' }}
                    >
                      {p.prices?.op0?.map((p) => p.v).join(' / ')}
                    </Row>
                  ))}
                </Column>
              </TableCell>
            )}

            {(tab === 6 || tab === 7) && (
              <TableCell width={WIDTH_POSTING[4]} center>
                <Column style={{ alignItems: 'center' }}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <>
                      {tab === 6 ? (
                        <div key={`${order.posting_number}-${p.offer_id}-17`} className={styles.div_line}>
                          {IP_NUMBER_MAP[p.ip_id]}
                        </div>
                      ) : (
                        <Select
                          select={p.ip_id}
                          list={IP_LIST_NUMBER}
                          style={{ fontSize: '16px' }}
                          width={'150px'}
                          valueFn={(v) => IP_MAP[v]?.name}
                          changeDifernceStatus
                          onSelect={(v) =>
                            onChangeProduct(order.posting_number, p._id, 'ip_id', v === 'Нет' ? null : parseInt(v))
                          }
                          {...props}
                        />
                      )}
                    </>
                  ))}
                </Column>
              </TableCell>
            )}

            <TableCell width={WIDTH_POSTING[4]} center>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-17`} className={styles.div_line}>
                    {MARKET_IP[order.shop]}
                  </div>
                ))}
              </Column>
            </TableCell>

            <TableCell width={WIDTH_POSTING[4]} center>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-18`} className={styles.div_line}>
                    {p?.stock_41?.reserved?.map((item) => `${IP_NUMBER_MAP[item.ip_id]} - ${item.quantity}`).join(', ')}
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[4]} center>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-18`} className={styles.div_line}>
                    {stocks1cArray
                      ?.filter((item) =>
                        item.skus.includes(
                          p.stock_41?.extra_sku_1c?.length > 0 ? p.stock_41?.extra_sku_1c : p.provider_sku,
                        ),
                      )
                      ?.map((item) => `${IP_NUMBER_MAP[item.ip_id]} - ${item.quantity} (${item.available})`)
                      .join(', ')}
                  </div>
                ))}
              </Column>
            </TableCell>
          </>
        )}

        {shipmentMode === MODES[0] && (
          <>
            <TableCell width={WIDTH_POSTING[4]} center>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-16`} className={styles.div_line}>
                    {p.provider_sku}
                  </div>
                ))}
                {/* {order.sim_products_stock1c?.join(', ')} */}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[4]} center>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-16`} className={styles.div_line}>
                    <Input
                      value={p.stock_41?.extra_sku_1c}
                      onBlur={(v) => onChangeProduct(order.posting_number, p._id, 'extra_sku_1c', v)}
                    />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[4]} minWidth={WIDTH_POSTING[4]}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-15`} className={styles.div_line}>
                    <ProviderList selectProviderId={p.provider_id} disabled={true} />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[5]} minWidth={WIDTH_POSTING[5]} center={true}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key

                  <Row key={`${order.posting_number}-${p.offer_id}-19`} className={styles.div_line} center={true}>
                    {(p['diff'].comment || '').length > 0 ? (
                      <>
                        <Tooltip text={p['diff'].comment}>
                          {p.diff.status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}{' '}
                          *
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        {p['diff'].status}{' '}
                        {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}
                      </>
                    )}
                  </Row>
                ))}
              </Column>
            </TableCell>

            <TableCell width={WIDTH_POSTING[4]} minWidth={WIDTH_POSTING[4]} center={true}>
              <div
                className={cn(
                  styles.status,
                  order.status === 'Ожидает отгрузки' && styles.process,
                  order.status === 'Не принят на CЦ' && styles.waiting,
                  order.status === 'Идёт приёмка' && styles.waiting,
                  order.status === 'Доставляется' && styles.sorted,
                  order.status === 'Прибыл на ПВЗ' && styles.pickup,
                  order.status === 'Продано' && styles.sold,
                  order.status === 'Доставлено' && styles.sold,
                  order.status === 'Отменено' && styles.canceled,
                  order.status === 'Отменено клиентом' && styles.controversial,
                  order.status === 'Арбитраж' && styles.controversial,
                  order.status === 'Обнаружен брак' && styles.waiting,
                  order.cancellation?.is_return && styles.return,
                )}
              >
                {order.cancellation?.is_return ? 'Возврат' : order.status}

                {order.delivering_status_update_date && (
                  <div className={styles.scan_time_posting_sc}>{formFullDate(order.delivering_status_update_date)}</div>
                )}
              </div>
            </TableCell>
            <TableCell width={WIDTH_POSTING[7]}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-15`} className={styles.div_line}>
                    <BarcodesBlock
                      barcodes={p.barcodes}
                      onAdd={(b) => onChangeProduct(order.posting_number, p._id, 'barcodes', b, 'add')}
                      onRemove={(b) => onChangeProduct(order.posting_number, p._id, 'barcodes', b, 'pull')}
                    />
                  </div>
                ))}
              </Column>

            </TableCell>

            <TableCell>
              {(tab === 2 || tab === 3 || tab === 4) && (
                <Column style={{ alignItems: 'center' }}>
                  {order.products.map((p, k) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={`${order.posting_number}-${p.offer_id}-16`} className={styles.div_line}>
                      <Button
                        type={TYPE_BUTTONS.RED}
                        onClick={() => Stocks1cApi.dereserveByPostingProduct({ data: { postingNumber: order.posting_number, productId: p._id } })}
                      >
                        Снять резерв
                      </Button>
                    </div>
                  ))}
                </Column>
              )}
            </TableCell>
          </>
        )}
        {shipmentMode === MODES[1] && (
          <>
            <TableCell width={WIDTH_POSTING[5]} minWidth={WIDTH_POSTING[5]} center={true}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key

                  <Row key={`${order.posting_number}-${p.offer_id}-19`} className={styles.div_line} center={true}>
                    {(p['diff'].comment || '').length > 0 ? (
                      <>
                        <Tooltip text={p['diff'].comment}>
                          {p.diff.status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}{' '}
                          *
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        {p['diff'].status}{' '}
                        {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}
                      </>
                    )}
                  </Row>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[4]} minWidth={WIDTH_POSTING[4]} center={true}>
              <div
                className={cn(
                  styles.status,
                  order.status === 'Ожидает отгрузки' && styles.process,
                  order.status === 'Не принят на CЦ' && styles.waiting,
                  order.status === 'Идёт приёмка' && styles.waiting,
                  order.status === 'Доставляется' && styles.sorted,
                  order.status === 'Прибыл на ПВЗ' && styles.pickup,
                  order.status === 'Продано' && styles.sold,
                  order.status === 'Доставлено' && styles.sold,
                  order.status === 'Отменено' && styles.canceled,
                  order.status === 'Отменено клиентом' && styles.controversial,
                  order.status === 'Арбитраж' && styles.controversial,
                  order.status === 'Обнаружен брак' && styles.waiting,
                  order.cancellation?.is_return && styles.return,
                )}
              >
                {order.cancellation?.is_return ? 'Возврат' : order.status}

                {order.delivering_status_update_date && (
                  <div className={styles.scan_time_posting_sc}>{formFullDate(order.delivering_status_update_date)}</div>
                )}
              </div>
            </TableCell>

            <TableCell width={WIDTH_POSTING[4]} minWidth={WIDTH_POSTING[4]}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-15`} className={styles.div_line}>
                    <ProviderList selectProviderId={p.provider_id} disabled={true} />
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[4]} center>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p.offer_id}-16`} className={styles.div_line}>
                    {p.provider_sku}
                  </div>
                ))}
              </Column>
            </TableCell>
          </>
        )}

        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
    </>
  );
};

export default PostingLine;
